import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import config from '../../config';
import { getI18n } from 'react-i18next';

class GridTranslatableCell extends Component {
    render() {
        let value = this.props.value;
        try {
            value = JSON.parse(value);
        } catch (e) {
            console.log('error', e);
        }
        const i18CurrentLanguage = getI18n().language || config.language;
        return (
            <TableCell key={this.props.field.id} align="left">
                {value[i18CurrentLanguage] || ''}
            </TableCell>
        );
    }
}

export default GridTranslatableCell;
